<template>
  <div class="container">
    <div class="detail-header">
      <div
        class="detail-poi van-hairline--surround"
        :data-bid="$BID.TRADE_EFFECT_POI_MC"
        :data-cid="$CID.TradeEffectData"
        @click="showSelectPop=true"
      >
        {{ poiName }}
        <van-icon name="arrow" />
      </div>
      <div class="detail-time gray-label">
        {{ $dayjs().subtract(1,'day').format('MM/DD') }}更新
      </div>
    </div>
    <div class="gray-label range">
      近90天（{{ startDate }} - {{ endDate }}）
    </div>
    <div class="data">
      <div>
        <div class="gray-label">
          订单量
        </div>
        <div class="num">
          {{ bizClearOrderCnt }}
        </div>
      </div>
      <div>
        <div class="gray-label">
          计入生意通订单量
        </div>
        <div class="num">
          {{ bizManOrderCnt }}
        </div>
      </div>
    </div>
    <select-poi
      :show="showSelectPop"
      :poi-id="poiId"
      @select="onSelect"
      @close="showSelectPop=false"
    />
  </div>
</template>

<script>
import SelectPoi from './tradeEffect/SelectPoi';
import Api from '@/api/marketing';

export default {
  name: 'TradeEffectData',
  components: { SelectPoi },
  data() {
    return {
      poiName: '',
      poiId: 0,
      showSelectPop: false,
      bizClearOrderCnt: '-',
      bizManOrderCnt: '-',
      startDate: this.$dayjs().subtract(91, 'day').format('YYYY/MM/DD'),
      endDate: this.$dayjs().subtract(1, 'day').format('YYYY/MM/DD'),
    };
  },
  created() {
    this.onSelect(this.$route.query);
  },
  methods: {
    onSelect(poi) {
      const { poiId, poiName } = poi;
      this.poiName = poiName;
      this.poiId = Number(poiId);
      this.getTradeData();
    },
    async getTradeData() {
      this.bizClearOrderCnt = '-';
      this.bizManOrderCnt = '-';
      this.startDate = this.$dayjs().subtract(91, 'day').format('YYYY/MM/DD');
      this.endDate = this.$dayjs().subtract(1, 'day').format('YYYY/MM/DD');

      const { error, data } = await Api.getTradeData(this.poiId);
      if (!error && data) {
        this.bizClearOrderCnt = data.bizClearOrderCnt;
        this.bizManOrderCnt = data.bizManOrderCnt;
        this.startDate = data.startDate;
        this.endDate = data.endDate;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  margin: 18px;
  padding: 30px;
  border-radius: 12px;
  background: white;
}
.detail-header{
  display: flex;
  align-items: center;
  .detail-poi{
    padding: 12px;
    flex: 1;
    font-size: 28px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    /deep/ .van-icon {
      margin-top: 4px;
    }
  }

  .detail-time{
    margin-left: 40px;
  }
}
.gray-label {
  color: #999;
  font-size: 22px;
}
.range{
  margin-top: 20px;
  text-align: left;
}
.data {
  display: flex;
  justify-content: space-between;
  padding: 12px 0;

  .num {
    font-size: 28px;
    font-weight: bold;
    text-align: left;
  }
}
</style>
